import React from 'react';
import './ProjectCard.css'; // Import the CSS file for styling

const ProjectCard = ({ image, title, description, link }) => {
  return (
    <div className="project-card">
      <img src={image} alt={title} className="project-card-image" style={{ height: '170px' ,width:'370px',borderRadius:'4px'}}/>
      <div className="project-card-content">
        <h3 className="project-card-title">{title}</h3>
        <p className="project-card-description">{description}</p>
        <a href={link} className="project-card-link" target="_blank" rel="noopener noreferrer">
          View Project
        </a>
      </div>
    </div>
  );
};

export default ProjectCard;
